import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import AuthPage from "@/pages/AuthPage";
import UserDashboard from "@/pages/UserDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TransactionMonitor from "@/pages/TransactionMonitor";
import CustomerManagement from "@/pages/CustomerManagement";
import LicenseManagement from "@/pages/LicenseManagement";
import CouponManagement from "@/pages/CouponManagement";
import SalesHistory from "@/pages/SalesHistory";
import BillingManagement from "@/pages/BillingManagement";
import RevenueManagement from "@/pages/RevenueManagement";
import UserManagement from "@/pages/UserManagement";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import EmbedBookingWidget from "@/pages/EmbedBookingWidget";
import EmbedManagement from "@/pages/EmbedManagement";
import MerchantTransactions from "@/pages/MerchantTransactions";
import PlatformSettings from "@/pages/PlatformSettings";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/embed/:embedToken" element={<EmbedBookingWidget />} />
          
          {/* User dashboard */}
          <Route path="/dashboard" element={<UserDashboard />} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/transactions" element={<TransactionMonitor />} />
          <Route path="/admin/customers" element={<CustomerManagement />} />
          <Route path="/admin/licenses" element={<LicenseManagement />} />
          <Route path="/admin/coupons" element={<CouponManagement />} />
          <Route path="/admin/sales" element={<SalesHistory />} />
          <Route path="/admin/billing" element={<BillingManagement />} />
          <Route path="/admin/revenue" element={<RevenueManagement />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/embeds" element={<EmbedManagement />} />
          <Route path="/admin/merchant" element={<MerchantTransactions />} />
          <Route path="/admin/settings" element={<PlatformSettings />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
